import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IAiPromptUsersStore,
  IGetPromptUsersRequest,
  IUsersSearchRequest,
  IUsersSearchResponse,
  IModelServersResponse,
} from './types';
import { IGetPromptUsersResponse, IUserRequest } from 'services/api/aiPrompts/types';

export const initialState: IAiPromptUsersStore = {
  users: null,
  searchUsers: null,
  modelServers: null,
  loader: false,
};

const aiPromptUsers = createSlice({
  name: '@@aiPromptUsers',
  initialState,
  reducers: {
    getModelServersRequest: (state) => {
      state.loader = true;
    },
    getModelServersSuccess: (state, action: PayloadAction<IModelServersResponse>) => {
      state.modelServers = action.payload;
    },

    getPromptUsersRequest: (state, _action: PayloadAction<IGetPromptUsersRequest>) => {
      state.loader = true;
    },
    getPromptUsersSuccess: (state, action: PayloadAction<IGetPromptUsersResponse>) => {
      state.users = action.payload;
    },

    addPromptUserRequest: (state, _action: PayloadAction<IUserRequest>) => {
      state.loader = true;
    },
    addPromptUserSuccess: (state) => {},

    updatePromptUserRequest: (
      state,
      _action: PayloadAction<{ id: string; payload: IUserRequest }>,
    ) => {
      state.loader = true;
    },
    updatePromptUserSuccess: (state) => {},

    deletePromptUserRequest: (state, _action: PayloadAction<{ botId: string; userId: string }>) => {
      state.loader = true;
    },
    deletePromptUserSuccess: (state) => {},

    searchUsersRequest: (state, _action: PayloadAction<IUsersSearchRequest>) => {
      state.loader = true;
    },
    searchUsersSuccess: (state, action: PayloadAction<IUsersSearchResponse>) => {
      state.searchUsers = action.payload;
    },

    aiPromptUsersInitState: (state) => {
      state.loader = false;
    },
  },
});

export default aiPromptUsers.reducer;
export const {
  getModelServersRequest,
  getModelServersSuccess,
  getPromptUsersRequest,
  getPromptUsersSuccess,
  addPromptUserRequest,
  addPromptUserSuccess,
  updatePromptUserRequest,
  updatePromptUserSuccess,
  deletePromptUserRequest,
  deletePromptUserSuccess,
  searchUsersRequest,
  searchUsersSuccess,
  aiPromptUsersInitState,
} = aiPromptUsers.actions;
